import { render, staticRenderFns } from "./EventPackageOfferHotelsEmptyState.vue?vue&type=template&id=3c4c8c35&scoped=true&"
import script from "./EventPackageOfferHotelsEmptyState.vue?vue&type=script&lang=js&"
export * from "./EventPackageOfferHotelsEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./EventPackageOfferHotelsEmptyState.vue?vue&type=style&index=0&id=3c4c8c35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c8c35",
  null
  
)

export default component.exports